import React, { useState } from 'react'
import { Button, Card, Col, Input, Row, Select, Table, TimePicker, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import mealSchedulesData from '../utils/mealSchedules.json'
import dayjs from 'dayjs'

const { Title, Text } = Typography
const { Option } = Select

const MealSchedule = ({ data, setData }) => {
  const [selectedMealType, setSelectedMealType] = useState('')
  const [selectedTime, setSelectedTime] = useState(null)
  const [selectedDays, setSelectedDays] = useState([])
  const [notes, setNotes] = useState('')

  const mealTypes = mealSchedulesData.mealTypes
  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']

  const handleAddMeal = () => {
    if (selectedMealType && selectedTime) {
      const formattedTime = selectedTime.format('HH:mm')

      const newMeal = {
        id: Date.now(),
        mealType: selectedMealType,
        time: formattedTime,
        days: selectedDays.length ? selectedDays : [...daysOfWeek], // If no days selected, default to all days
        notes
      }

      setData([...data, newMeal])

      // Reset form
      setSelectedMealType('')
      setSelectedTime(null)
      setSelectedDays([])
      setNotes('')
    }
  }

  const handleRemoveMeal = (id) => {
    setData(data.filter((item) => item.id !== id))
  }

  const columns = [
    {
      title: 'Meal Type',
      dataIndex: 'mealType',
      key: 'mealType'
    },
    {
      title: 'Time',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: 'Days',
      dataIndex: 'days',
      key: 'days',
      render: (days) => days.join(', ')
    },
    {
      title: 'Notes',
      dataIndex: 'notes',
      key: 'notes'
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Button
          danger
          icon={<FontAwesomeIcon icon={faTrash} />}
          onClick={() => handleRemoveMeal(record.id)}
          size='small'
        />
      )
    }
  ]

  return (
    <div>
      <Title level={4}>Meal Schedule & Planning</Title>
      <Text>Set up the meal schedule including times, frequency, and meal types.</Text>

      <Card style={{ marginTop: 16, marginBottom: 16 }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={12}>
            <Text strong>Meal Type</Text>
            <Select
              placeholder='Select meal type'
              style={{ width: '100%' }}
              value={selectedMealType}
              onChange={(value) => setSelectedMealType(value)}
            >
              {mealTypes.map((type) => (
                <Option key={type} value={type}>
                  {type}
                </Option>
              ))}
            </Select>
          </Col>

          <Col xs={24} md={12}>
            <Text strong>Time</Text>
            <TimePicker
              style={{ width: '100%' }}
              value={selectedTime}
              onChange={(time) => setSelectedTime(time)}
              format='HH:mm'
            />
          </Col>

          <Col span={24}>
            <Text strong>Days of Week</Text>
            <Select
              mode='multiple'
              placeholder='Select days (defaults to all days if none selected)'
              style={{ width: '100%' }}
              value={selectedDays}
              onChange={(value) => setSelectedDays(value)}
            >
              {daysOfWeek.map((day) => (
                <Option key={day} value={day}>
                  {day}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={24}>
            <Text strong>Additional Notes</Text>
            <Input.TextArea
              rows={4}
              placeholder='Enter any additional meal schedule notes'
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </Col>

          <Col span={24}>
            <Button
              type='primary'
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={handleAddMeal}
              disabled={!selectedMealType || !selectedTime}
            >
              Add Meal to Schedule
            </Button>
          </Col>
        </Row>
      </Card>

      <Table dataSource={data} columns={columns} rowKey='id' pagination={false} size='small' />
    </div>
  )
}

export default MealSchedule
